import React from "react";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import { getTokens } from "../../styles/tokens";

const useStyles = makeStyles(theme => {
	const t = getTokens(theme.palette.type, theme.palette.primary.main);
	return {
		title: {
			fontFamily: t.font,
			...t.type.pageHeading,
			color: t.text,
			margin: 0,
			display: "flex",
			alignItems: "center",
			gap: 10,
			minWidth: 0,
			textWrap: "balance",
		},
	};
});

/**
 * Título de página (h1 visual) — clamp(22px, 2.1vw, 28px)/700, sem cor da marca.
 * API igual à anterior: só `children`. Aceita `className` extra.
 */
export default function Title(props) {
	const classes = useStyles();
	const { children, className, ...rest } = props;
	return (
		<Typography
			variant="h5"
			component="h1"
			className={[classes.title, "kp-page-title", className]
				.filter(Boolean)
				.join(" ")}
			{...rest}
		>
			{children}
		</Typography>
	);
}
